<div class="min-h-screen ui-app-shell font-roboto">
  <app-spinner
    class="ui-overlay-backdrop fixed inset-0 z-50 flex items-center justify-center transition-all duration-300 ease-out"
    [class.opacity-0]="!loadingService.visible()"
    [class.pointer-events-none]="!loadingService.visible()"
  >
  </app-spinner>

  <router-outlet />
</div>
